<template>
  <section class="manu-apply">
    <!--todo 招行保证金-->
    <!--<newApplyHeader :currentStep="appChannel==='zhaohang'?3:2"></newApplyHeader>-->
    <newApplyHeader currentStep="3"></newApplyHeader>
    <div class="header">
      <span>所需证件</span>
      <div class="more-wrap" color-primary @click="m_customService">了解更多<i color-primary class="iconfont etc-icon-qa"></i></div>
    </div>
    <section class="img-box">
      <img src="../../assets/apply/order-info-img.png" alt="">
      <!--<div>-->
        <!--<img src="../../assets/apply/card-type-idcard.png"/>-->
        <!--<span class="text">身份证</span>-->
      <!--</div>-->
      <!--<div>-->
        <!--<img src="../../assets/apply/card-type-headstock.png"/>-->
        <!--<span class="text">车头照</span>-->
      <!--</div>-->
      <!--<div>-->
        <!--<img src="../../assets/apply/card-type-driving-license.png"/>-->
        <!--<span class="text">行驶证</span>-->
      <!--</div>-->
    </section>
    <div class="tip" has-dot primary-dot>
      <span class="dot">•</span>
      <p>个人资料用于定制设备，定制后不支持无理由退货</p>
    </div>
    <div class="tip" has-dot primary-dot>
      <span class="dot">•</span>
      <p>根据交通部规定，一辆车只能办理1张ETC卡，专车专用</p>
    </div>
    <div class="tip" has-dot primary-dot>
      <span class="dot">•</span>
      <p>暂不支持<span color-primary>货车</span>申办</p>
    </div>
    <div class="header">
      <span>订单信息</span>
    </div>
    <div class="order-info">
      <div class="order-header" :class="showOrder?'show':''">
        <div>
          <p class="card-type" v-if="currentCard.is_king">ETC 王卡（全国通行）</p>
          <p class="card-type" v-else>{{currentCard.issuer_name + '-' + (currentCard.card_type===1?'记账卡':'储值卡') + '（全国通行）'}}</p>
          <p class="discount-tip" v-show="discount">使用{{currentCard.is_king?'ETC王卡':currentCard.issuer_name}}在{{(currentOrder.send_area||'').split(' ')[0]}}通行，享<span color-primary>{{discount}}</span>折优惠</p>
        </div>
        <i class="iconfont" :class="showOrder?'etc-icon-arrow-up':'etc-icon-arrow-down'" @click="showOrder = !showOrder"></i>
      </div>
      <template v-if="showOrder">
        <p class="order-line" margin-t-30>
          <span>收货人</span> <span>{{currentOrder.send_name || '-'}}</span>
        </p>
        <p class="order-line">
          <span>收货地址</span> <span>{{currentOrder.send_name + ' ' + currentOrder.send_phone + ' ' + currentOrder.send_area + ' ' + currentOrder.send_address}}</span>
        </p>
        <p class="order-line">
          <span>订单编号</span> <span>{{currentOrder.order_sn || '-'}}</span>
        </p>
        <p class="order-line">
          <span>实际付款</span> <span>{{currentOrder.need_pay || '-'}}元</span>
        </p>
        <div class="order-new-line">
          <p class="order-line"><span>付款时间</span> <span>{{currentOrder.created_at || '-'}}</span></p>
          <span class="cancel-btn" @click="m_goPages('cancelOrder')">取消订单</span>
        </div>
      </template>
      <div class="fixed-bottom"></div>
    </div>

    <section class="apply-bottom">
      <div class="agreement-box">
        <div class="check-wrap" @click="clickAgree">
          <i class="iconfont" :class="agreeProtocol?'etc-icon-checked':'etc-icon-uncheck'"></i>
        </div>
        <div class="agreement">
          <span>我已阅读并同意</span>
          <span v-if="appChannel==='zhaohang'" color-blue @click="goProtocol('CMB_BANK_SERVE_PROTOCOL')">《ETC用户服务协议》</span>
          <span v-else-if="currentCard.is_king" color-blue @click="goProtocol('KING_OBU_USE_PROTOCOL')">《ETC王卡与电子标签使用协议》</span>
          <template v-else>
            <span v-if="currentIssuer.id !== ETC.ISSUER_IDS.gd" color-blue @click="goProtocol('OBU_USE_PROTOCOL')">{{ protocolName }}</span>
            <span v-if="currentIssuer.id === ETC.ISSUER_IDS.gd" color-blue @click="goProtocol('OBU_USER_PLATEFORM_PROT')">《粤通卡用户协议》</span>
            <span v-if="currentIssuer.id === ETC.ISSUER_IDS.gd || currentIssuer.id === ETC.ISSUER_IDS.gz" color-black>及</span>
            <span v-if="currentIssuer.id === ETC.ISSUER_IDS.gd" color-blue @click="goProtocol('OBU_USE_PROTOCOL')">《粤通卡电子标签使用协议》</span>
            <span v-if="currentIssuer.id === ETC.ISSUER_IDS.gz" color-blue @click="goProtocol('VALUE_ADDED_SERVICE')">《黔通卡基础服务用户协议》</span>
            <span v-if=" currentIssuer.id === ETC.ISSUER_IDS.qh" color-blue @click="goProtocol('OBU_USE_PROTOCOL')">{{currentCard.card_type === 2 ? '《青通卡（储值）使用章程》' : '《青通记账卡与电子标签使用协议》'}}</span>
          </template>
          </div>
      </div>
      <button cool-btn :class="{'disabled': !agreeProtocol}" @click="apply">开始上传资料</button>
      <div class="fixed-bottom"></div>
    </section>
    <popup ref="agreementPopup">
      <div slot="content" class="popup-container">
        <header>协议须知</header>
        <section class="popup-content">
          <div class="popup-content-line">
            <span>我已了解，遵守并同意</span>
          </div>
          <div class="popup-content-line" color-blue has-dot blue-dot v-if="appChannel==='zhaohang'" @click="goProtocol('CMB_BANK_SERVE_PROTOCOL')">
            <span class="dot">•</span>
            <p>《ETC用户服务协议》</p>
          </div>
          <div class="popup-content-line" color-blue has-dot blue-dot v-else-if="currentCard.is_king" @click="goProtocol('KING_OBU_USE_PROTOCOL')">
            <span class="dot">•</span>
            <p>《ETC王卡与电子标签使用协议》</p>
          </div>
          <template v-else>
            <div class="popup-content-line" color-blue has-dot blue-dot v-if="currentIssuer.id !== ETC.ISSUER_IDS.gd" @click="goProtocol('OBU_USE_PROTOCOL')">
              <span class="dot">•</span>
              <p>{{ protocolName }}</p>
            </div>
            <div class="popup-content-line" color-blue has-dot blue-dot v-if="currentIssuer.id === ETC.ISSUER_IDS.gd" @click="goProtocol('OBU_USER_PLATEFORM_PROT')">
              <span class="dot">•</span>
              <p>《粤通卡用户协议》</p>
            </div>
            <div class="popup-content-line" color-blue has-dot blue-dot  v-if="currentIssuer.id === ETC.ISSUER_IDS.gd" @click="goProtocol('OBU_USE_PROTOCOL')">
              <span class="dot">•</span>
              <p>《粤通卡电子标签使用协议》</p>
            </div>
            <div class="popup-content-line" color-blue has-dot blue-dot v-if="currentIssuer.id === ETC.ISSUER_IDS.gz" @click="goProtocol('VALUE_ADDED_SERVICE')">
              <span class="dot">•</span>
              <p>《黔通卡基础服务用户协议》</p>
            </div>
            <div class="popup-content-line" color-blue has-dot blue-dot v-if="currentIssuer.id === ETC.ISSUER_IDS.qh" @click="goProtocol('OBU_USE_PROTOCOL')">
              <span class="dot">•</span>
              <p>{{currentCard.card_type === 2 ? '《青通卡（储值）使用章程》' : '《青通记账卡与电子标签使用协议》'}}</p>
            </div>
          </template>
        </section>
        <button cool-btn @click="checkAgreement">确认</button>
      </div>
    </popup>
  </section>
</template>

<script>
// mixins
import FunMixin from '@/mixins/funMixin'
// components
import Popup from '@/components/cool.popup'
import NewApplyHeader from '@/components/etc.newApplyHeader'
// store
import {mapState, mapMutations} from 'vuex'
// config
import ETC from '@/config/etc.config'
// import reconApply from '@/api/reconApply.api'

let customData = {
  agreeProtocol: ''
}

export default {
  name: 'manuApply',
  mixins: [FunMixin],
  components: {
    NewApplyHeader,
    Popup
  },
  data() {
    return {
      showOrder: false,
      discount: '',
      ETC,
      agreeProtocol: true
    }
  },
  computed: {
    protocolName() {
      const protocol = this.currentIssuer.name || '记账卡'
      return `《微行联名${protocol}/电子标签使用协议》`
    },
    ...mapState([
      'currentIssuer',
      'currentCard',
      'currentOrder'
    ])
  },
  methods: {
    async apply() {
      await this.m_clickDebounce('apply')
      if (!this.agreeProtocol) {
        this.$refs.agreementPopup.$emit('showPopup', {class: 'agreement-popup'})
        return
      }
      this.$router.push('uploadIDCard')
    },
    checkAgreement() {
      this.$refs.agreementPopup.$emit('hidePopup')
      this.agreeProtocol = true
      customData.agreeProtocol = true
    },
    clickAgree() {
      this.agreeProtocol = !this.agreeProtocol
      customData.agreeProtocol = this.agreeProtocol
    },
    goProtocol(protocolName) {
      if (protocolName === 'OBU_USE_PROTOCOL' && this.currentCard.card_type === 2) {
        // 如果是储值卡则跳储值卡协议
        protocolName = 'RECHARGE_OBU_USE_PROTOCOL'
      }
      this.m_goPagesWithQ('agreement', {agreementType: protocolName, issuerId: protocolName === 'CMB_BANK_SERVE_PROTOCOL' ? '1' : ''})
    },
    ...mapMutations([
      'setUserApplyStep',
      'setCurrentOrder',
      'setApplyStepList'
    ])
  },
  async mounted() {
    // const {order, step_list} = await reconApply.getApplyCurrentOrder({order_sn: this.currentOrder.apply_order_sn})
    // 保存发卡方，卡信息
    // this.setCurrentIssuer(order.card_issuer)
    // this.setCurrentCard(order.card)
    // this.setCurrentOrder(order)
    // this.setApplyStepList(step_list)
    // ETC.ISSUER_DISCOUNT[this.currentCard.issuer_name] && (this.discount = ETC.ISSUER_DISCOUNT[this.currentCard.issuer_name].discount(this.currentOrder.send_area.split(' ')[0], this.currentCard.card_type))
    if (this.currentIssuer.id === ETC.ISSUER_IDS.gx) {
      this.m_showConfirm({content: '受系统升级影响，您申办的八桂行卡将于7个工作日内完成审核', noCancel: true, confirmBtn: '知道了'})
    }
  }
}
</script>

<style scoped lang="scss">
@import "../../style/cool.practical";
.manu-apply{
  padding-bottom: 230px;
  .header{
    margin: 40px 40px 0;
    @extend %flex-space-between;
    span {
      font-size: 36px;
      padding-left: 24px;
      @include title-before(4px, 40px)
    }
    .more-wrap{
      color: #999999;
      font-size: 28px;
      i{
        font-size: 36px;
        margin-left: 10px;
      }
    }
    [color-blue]{
      font-size: 24px;
    }
  }
  .img-box{
    padding: 30px 50px;
    img{
      width: 423px;
      height: 207px;
    }
    /*@extend %flex-space-between;
    img{
      width: 196px;
      height: 124px;
      background-color: #ffffff;
      display: block;
    }
    .text{
      font-size: 26px;
      color: #666666;
      margin-top: 15px;
      display: block;
      text-align: center;
    }*/
  }
  .tip{
    padding: 0 40px;
    font-size: 24px;
    color: #666666;
  }
  .order-info{
    margin: 30px 40px 20px;
    padding: 20px 30px;
    position: relative;
    border: 1px dashed transparent;
    border-radius: 8px;
    background: linear-gradient(white,white) padding-box, repeating-linear-gradient(-45deg,#ccc 0, #ccc 8px,white 0,white 0.4em);
    .order-header{
      font-size: 24px;
      @extend %flex-space-between;
      .card-type{
        font-size: 28px;
        font-weight: bold;
      }
      .discount-tip{
        margin-top: 10px;
      }
      .iconfont{
        color: #999999;
        font-size: 32px;
      }
      &.show{
        border-bottom: 1px solid #dddddd;
        padding-bottom: 20px;
      }
    }
    .order-new-line{
      line-height: 60px;
      @extend %flex-space-between;
      .cancel-btn{
        font-size: 26px;
        color: #999999;
      }
    }
    .order-line{
      font-size: 26px;
      color: #333333;
      line-height: 60px;
      @extend %flex-start;
      span:first-child{
        width: 130px;
        flex-shrink: 0;
        color: #999999;
      }
    }
  }
  .apply-bottom {
    padding: 20px 55px 30px;
    position: fixed;
    bottom: 0;
    left: 0;
    width: 100%;
    /*height: 230px;*/
    background-color: #fff;
    .agreement-box{
      padding-bottom: 20px;
      @extend %flex-center-start;
      .check-wrap{
        padding: 20px;
        margin-left: -20px;
        margin-top: -20px;
        align-self: flex-start;
        display: flex;
        .iconfont{
          font-size: 40px;
        }
        .etc-icon-uncheck{
          color: #cccccc;
        }
        .etc-icon-checked{
          color: $primary-color;
        }
      }
      .agreement{
        font-size: 26px;
        color: #333333;
        align-self: flex-start;
      }
    }
    .btn-wrap {
      width: 100%;
      text-align: center;
    }
  }
  .agreement-popup{
    .popup-container{
      padding: 0 40px 40px;
      background-color: #fff;
      border-radius: 10px;
      min-width: calc(100vw - 160px);
      max-width: calc(100vw - 100px);
    }
    header {
      font-size: 40px;
      padding: 35px;
      text-align: center;
    }
    .popup-content {
      padding: 0 0 40px 20px;
      .popup-content-line {
        margin-top: 20px;
        font-size: 30px;
        color: #0A0B0C;
        white-space: nowrap;
        &:first-child {
          margin-top: 0;
        }
      }
    }
  }
}
</style>
